import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { StarBorder, Star } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { projectsAtom } from '@/interfaces/group';
import { patchProject } from '@/interfaces/project';

interface StarButtonProps {
  projectId: string;
  projectName: string;
  priority: boolean;
}

export default function StarButton({ projectId, projectName, priority }: StarButtonProps) {
  const { refetch } = useAtomValue(projectsAtom);

  const [starred, setStarred] = useState(priority);
  const { t } = useTranslation();

  async function onStarClick() {
    setStarred(!starred);
    const isSuccess = await patchProject(projectId, projectName, !starred);
    if (isSuccess) {
      refetch();
    } else {
      window.alert(t('Common.message.serverErrorOccurred'));
      setStarred(starred);
    }
  }

  return <IconButton onClick={onStarClick}>{starred ? <Star color="primary" /> : <StarBorder />}</IconButton>;
}
